import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardText,
  Container,
  FormGroup,
  Input,
  Label,
} from 'reactstrap'
import { URL_EVENT_PARTNER } from 'utils/pathUrl'
import {
  useAddEventPartnerMutation,
  useEditEventPartnerMutation,
} from './eventPartnerApiSlice'
import InputPhoneNumber from 'components/InputPhoneNumber'

const FormEventPartner = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { enqueueSnackbar } = useSnackbar()
  const dataState = location.state

  const [payload, setPayload] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const [addEventPartner, resAddEventPartner] = useAddEventPartnerMutation()
  const [updateEventPartner, resUpdateEventPartner] =
    useEditEventPartnerMutation()

  const handleSubmit = async () => {
    try {
      const body = {
        ...payload,
      }
      const result = dataState
        ? await updateEventPartner(payload)
        : await addEventPartner(body)

      if (result?.error) {
        throw result
      } else {
        navigate(URL_EVENT_PARTNER)
        enqueueSnackbar(
          `Partner event berhasil ${dataState ? 'diubah' : 'ditambah'}`,
          {
            variant: 'success',
          },
        )
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.message ||
          error?.error?.message ||
          error?.error?.originalStatus ||
          error,
        {
          variant: 'error',
        },
      )
    }
  }

  useEffect(() => {
    if (dataState) {
      setPayload(dataState)
    }
  }, [dataState])

  return (
    <>
      <Container className="custom-container d-flex flex-column gap-1 py-2">
        <div className="pt-3">
          <BreadCrumbs
            breadCrumbActive={`${dataState ? 'Edit' : 'Tambah'} Partner event`}
            breadCrumbParent={'Partner event'}
            breadCrumbParentLink={URL_EVENT_PARTNER}
          />
        </div>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <CardText tag="h5" className="pb-4">
              {dataState ? 'Edit' : 'Tambah'} Partner event
            </CardText>
            <FormGroup>
              <Label>Nama</Label>
              <Input
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    name: e.target?.value,
                  }))
                }}
                value={payload?.name}
                id="eventPartnerName"
                name="eventPartnerName"
                placeholder="Masukkan nama"
                data-testid="event-partner-form-name"
              />
            </FormGroup>
            <FormGroup>
              <Label>Nomor telepon</Label>
              <InputPhoneNumber
                id="phone"
                name="phone"
                placeholder="Masukkan nomor telepon"
                value={payload?.phone ?? ''}
                setValue={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    phone: e,
                  }))
                }}
                testId="event-partner-form-phone"
              />
            </FormGroup>
            <FormGroup>
              <Label>Alamat</Label>
              <Input
                type="textarea"
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    address: e.target?.value,
                  }))
                }}
                value={payload?.address}
                id="address"
                name="address"
                placeholder="Masukkan alamat"
                data-testid="event-partner-form-address"
              />
            </FormGroup>

            <div className="d-flex gap-3">
              <CustomButton
                onClick={() => navigate(URL_EVENT_PARTNER)}
                outline
                className="btn-cancel"
                block
                testId="event-partner-form-cancel-button"
              >
                Batal
              </CustomButton>
              <CustomButton
                onClick={() => handleSubmit()}
                disabled={
                  isLoading ||
                  !payload?.name ||
                  !payload?.phone ||
                  !payload?.address
                }
                block
                color="primary"
                testId="event-partner-form-submit-button"
              >
                Simpan
              </CustomButton>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default FormEventPartner
